import { fetchApiData } from "client/utils/fetchApiData";
import { ClaimsSearchResponse } from "../../../../types";
import { GetUserClaimsRequest } from "../../../../types/actions";
import getQueryString from "../../../../utils/getQueryString";

export default (userClaimsReq: GetUserClaimsRequest): Promise<ClaimsSearchResponse> => {
  const queryString = userClaimsReq.filters ? getQueryString(userClaimsReq.filters) : "";
  return fetchApiData({ url: `/api/user/claims/${queryString}` });
};
